import styled from 'styled-components';
import { breakpoints, colors, typography } from '@99designs/ui/settings';

const Label = styled.label`
    font-size: ${typography.typeScale.size4}px;
    font-family: ${typography.fontFamilies.heading};
    line-height: ${typography.lineHeights.medium};
    display: inline-block;
    color: ${colors.puntRoad};

    @media (min-width: ${breakpoints.small[0]}px) and (max-width: ${breakpoints.medium[1]}px) {
        font-size: ${typography.typeScale.size3};
    }
`;

export default Label;
